import React from 'react'

function Prediction() {
  return (
    <div>Prediction</div>
  )
}

export default Prediction